import { render, staticRenderFns } from "./FxsScenicMange.vue?vue&type=template&id=71c615e6&scoped=true&"
import script from "./FxsScenicMange.vue?vue&type=script&lang=js&"
export * from "./FxsScenicMange.vue?vue&type=script&lang=js&"
import style0 from "./FxsScenicMange.vue?vue&type=style&index=0&id=71c615e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c615e6",
  null
  
)

export default component.exports